import { render } from "./BugReportDialog.vue?vue&type=template&id=eb20fbe8&ts=true"
import script from "./BugReportDialog.vue?vue&type=script&lang=ts"
export * from "./BugReportDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__